export enum WhatsAppSentStatus {
    Unspecified = 0,
    Sent = 1,
    Failed = 2,
}
